import { useEffect } from 'react';
import { CheckCircle2, Info, X, XCircle } from 'lucide-react';

export type ToastTone = 'success' | 'error' | 'info';

interface ToastProps {
  message: string;
  tone?: ToastTone;
  onClose: () => void;
}

const toneStyles = {
  success: 'border-emerald-500/40 bg-emerald-950 text-emerald-100',
  error: 'border-red-500/40 bg-red-950 text-red-100',
  info: 'border-purple-500/40 bg-dark-800 text-dark-100',
};

const Toast = ({ message, tone = 'info', onClose }: ToastProps) => {
  useEffect(() => {
    const timeoutId = window.setTimeout(onClose, 5000);
    return () => window.clearTimeout(timeoutId);
  }, [message]);

  const Icon = tone === 'success' ? CheckCircle2 : tone === 'error' ? XCircle : Info;

  return (
    <div
      className={`fixed right-4 top-4 z-[70] flex max-w-md items-start gap-3 rounded-lg border px-4 py-3 shadow-2xl ${toneStyles[tone]}`}
      role="status"
      aria-live="polite"
    >
      <Icon size={20} className="mt-0.5 shrink-0" />
      <p className="flex-1 text-sm leading-5">{message}</p>
      <button type="button" onClick={onClose} className="rounded p-0.5 hover:bg-white/10" aria-label="Fechar aviso">
        <X size={18} />
      </button>
    </div>
  );
};

export default Toast;
